module.exports = __webpack_public_path__ + "media/images/countryrect/my-c939d648e5cfb3c82a6a788553cef75a.svg";